export default __webpack_public_path__ + "static/media/attachment.8c54c1cb.svg";